export class UserInfo {
    sam_account_name!: string;
    display_name!: string;
    location!: string;
    org_code!: string;
    org_id!: string;
    postal_code!: string;
    mail!: string;
    gid!: string;
    city!: string;
    company_unit!: string;
    cost_center!: string;
    country!: string;
    address_location!: string;
    name!: string;
}